import type { NotificationProps } from './notification.types'

import { createContext } from '../utils'

const [NotificationProvider, useNotificationContext] = createContext<Partial<NotificationProps>>({ isOptional: true })

export { NotificationProvider, useNotificationContext }
